_ = require 'underscore'
isPlainObject = require 'lib/util/is-plain-object'

module.exports = (obj, predicate, transform) ->
  transform ?= (value, key, predicateResult) -> predicateResult

  process = (value, key) ->
    if (predicateResult = predicate(value, key))
      transform(value, key, predicateResult)
    else if _.isArray(value)
      value.map process
    else if isPlainObject(value)
      _.mapObject value, process
    else
      value

  process(obj)



// WEBPACK FOOTER //
// ./app/scripts/lib/util/deep-replace.coffee